module.exports = __webpack_public_path__ + "img/D2-d.a3e83b0e.jpg";